"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint-disable */
__exportStar(require("./Action"), exports);
__exportStar(require("./ActionStrategyId"), exports);
__exportStar(require("./ActionType"), exports);
__exportStar(require("./CreateAction201Response"), exports);
__exportStar(require("./CreateActionRequest"), exports);
__exportStar(require("./CreateEntry201Response"), exports);
__exportStar(require("./CreateEntryRequest"), exports);
__exportStar(require("./CreateGiveaway201Response"), exports);
__exportStar(require("./CreateGiveawayRequest"), exports);
__exportStar(require("./CreateGiveawayRequestStatistics"), exports);
__exportStar(require("./CreateGiveawaySchedulerConfig200Response"), exports);
__exportStar(require("./CreateGiveawaySchedulerConfigRequest"), exports);
__exportStar(require("./CreateVoucher201Response"), exports);
__exportStar(require("./CreateVoucherRequest"), exports);
__exportStar(require("./EntityMetadata"), exports);
__exportStar(require("./GetActions200Response"), exports);
__exportStar(require("./GetEntries200Response"), exports);
__exportStar(require("./GetGiveaway200Response"), exports);
__exportStar(require("./GetGiveawaySchedulerConfigs200Response"), exports);
__exportStar(require("./GetGiveaways200Response"), exports);
__exportStar(require("./GetGiveaways200ResponseData"), exports);
__exportStar(require("./GetStatistics200Response"), exports);
__exportStar(require("./GetVoucher200Response"), exports);
__exportStar(require("./GetVouchers200Response"), exports);
__exportStar(require("./GetVouchersCount200Response"), exports);
__exportStar(require("./GetVouchersCount200ResponseData"), exports);
__exportStar(require("./Giveaway"), exports);
__exportStar(require("./GiveawayAction"), exports);
__exportStar(require("./GiveawayAggregatedStatistics"), exports);
__exportStar(require("./GiveawayParticipantEntry"), exports);
__exportStar(require("./GiveawayProjection"), exports);
__exportStar(require("./GiveawaySchedulerConfig"), exports);
__exportStar(require("./GiveawaySchedulerConfigStatus"), exports);
__exportStar(require("./GiveawayStatistics"), exports);
__exportStar(require("./GiveawayStats"), exports);
__exportStar(require("./GiveawayStatsGrowth"), exports);
__exportStar(require("./GiveawayStatus"), exports);
__exportStar(require("./GiveawayVoucher"), exports);
__exportStar(require("./ModelError"), exports);
__exportStar(require("./SortOrder"), exports);
__exportStar(require("./UpdateGiveawayRequest"), exports);
__exportStar(require("./UpdateGiveawaySchedulerConfigRequest"), exports);
__exportStar(require("./UpdateVoucherRequest"), exports);
__exportStar(require("./UpsertStatisticsRequest"), exports);
__exportStar(require("./Voucher"), exports);
__exportStar(require("./VoucherOwner"), exports);
__exportStar(require("./VoucherReward"), exports);
__exportStar(require("./VoucherRewardType"), exports);
__exportStar(require("./VoucherStatus"), exports);
